import { useEffect, useContext } from "react";
import { ToastContext } from "../../context/ToastContext";
import { Form, Input, Spin, FormInstance } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { UserGroup } from "../../models/UserGroup";
import UserGroupService from "../../services/crud/UserGroupService";

const UserGroupForm = (props: {
  id: number,
  update: boolean,
  form: FormInstance<UserGroup>,
}) => {
  const id = props.id;
  const form = props.form;
  const update: boolean = props.update ?? false;
  const { loading, loadMessage } = useContext(ToastContext);

  useEffect(() => {
    form.resetFields();
    if (update) {
      loadMessage("Loading user group...", () =>
        UserGroupService.getUserGroup(id).then((data) => {
          const ug = data.serialize();
          form.setFieldsValue(ug);
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, form]);

  const content = (
    <Form form={form}>
      <Form.Item name="id" noStyle>
        <Input hidden={true} />
      </Form.Item>
      <Form.Item name="accountId" noStyle>
        <Input hidden={true} />
      </Form.Item>
      <Form.Item name="groupType" noStyle>
        <Input hidden={true} />
      </Form.Item>
      <Form.Item name="externalId" label="External ID">
        <Input type="text" disabled />
      </Form.Item>
      <Form.Item name="label" label="Label" rules={[{ required: true }]}>
        <Input type="text" />
      </Form.Item>
      <Form.Item name="description" label="Description">
        <Input type="text" />
      </Form.Item>
    </Form>
  );

  if (loading) {
    return (
      <Spin size="large" tip="Loading" indicator={<LoadingOutlined />}>
        {content}
      </Spin>
    );
  }
  return content;
};
export default UserGroupForm;
